import { WprBaseService } from '../wpr-framework/service/WprBaseService';
import { HttpUtils } from '../common/http/HttpUtils';

/**
 * サービス基本クラス
 */
export class BaseLineService extends WprBaseService {
	// public メソッド  ----------------------------------------------------------
	/**
	 * POST通信処理
	 * @param url URL
	 * @param request リクエスト情報
	 * @returns 通信結果Promiseオブジェクト
	 */
	public async executePost(url: string, request: any): Promise<any> {
		const baseUrl = process.env.API_ADDRESS_URL;
		// return await HttpUtils.doPostWithFetchApi(baseUrl + url, request, 5000);
		return await HttpUtils.doPost_t(url, request);
	}
	// --------------------------------------------------------------------------
}